function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgConsole(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#7D8898",
    fillRule: "evenodd",
    d: "M22.233 13.49v.142a2.726 2.726 0 01-2.727 2.727h-6.363v2.49h2.727a.91.91 0 010 1.818H8.597a.91.91 0 010-1.818h2.728v-2.49H4.96a2.726 2.726 0 01-2.727-2.727v-.143h19.999zM19.506 2.484a2.726 2.726 0 012.728 2.727l-.001 6.363h-20V5.212A2.727 2.727 0 014.796 2.49l.166-.005z"
  }));
}

SvgConsole.clsName = 'icon-www__console';
SvgConsole.remarkName = 'unknown';
export default SvgConsole;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Console.js
// module id = 2324
// module chunks = 17 18